import {useAdminUsersDashboardContext} from "root/s360components/AdminUsersDashboardContext";
import {Fragment} from "react";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import AdminGoogleLinks from "root/s360components/AdminGoogleLinks";
import AdminInternalLinks from "root/s360components/AdminInternalLinks";

const AdminDashboardLinks = ({school_id, user_id, user_type, concern_report_access, eschools_admin, online_safety_audit_enabled}) =>
{
    const {isLoading, data} = useAdminUsersDashboardContext();


    const pageContent = () =>
    {
        return (
            <Fragment>
                {isLoading === true && <SpinnerDiv/>}
                {isLoading === false &&
                    <Fragment>
                        <AdminGoogleLinks school_id={school_id} user_id={user_id} user_type={user_type} permissionFlags={{online_safety_audit_enabled: online_safety_audit_enabled, eschools_admin: eschools_admin}}/>

                        <AdminInternalLinks user_id={user_id} user_type={user_type} permissionFlags={{concern_report_access: concern_report_access}}/>
                    </Fragment>}
            </Fragment>
        )
    }

    return isLoading === true ? <SpinnerDiv/> : pageContent()
}

export default AdminDashboardLinks;